// extracted by mini-css-extract-plugin
export default {"mask":"index_mask_QzYIS","video_wp":"index_video_wp_5ohUg","close":"index_close_Ip0zG"};